import { createContext } from 'react';

export const ServiceOptionsContext = createContext();